
export class SplitBillItemModel {
  public menuItemId: string;
  public quantity: number;

}
